import React, { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { connect } from "react-redux";

import { HubHookFormWrapper } from "../../components";
import {
  useGetLeadDetails,
  usePostLead,
  usePutLead,
} from "../../hooks/react-query/useSalesData";
import { getIsDialogOpen, setIsOpenDialog } from "../../redux/dialogs";

import LeadBar from "./LeadBar";
import LeadDetails from "./LeadDetails";
import LeadTimeline from "./LeadTimeline";
import { StyledDrawer } from "./styles";

const DIALOG_NAME = "edit-lead";

const LeadDrawer = ({ open, _setIsOpenDialog = () => {} }) => {
  const isNew = open === true;
  const id = !isNew && open ? Number(open) : null;

  const { data: lead } = useGetLeadDetails(id);
  const { mutate: create, isSuccess: isCreateSuccess } = usePostLead();
  const { mutate: update, isSuccess: isUpdateSuccess } = usePutLead();

  const onClose = () => _setIsOpenDialog(DIALOG_NAME, false);
  const isSuccess = isCreateSuccess || isUpdateSuccess;

  useEffect(() => {
    if (isSuccess && isNew) onClose();
  }, [isSuccess]);

  const handleSubmit = (data) => {
    const payload = {
      companyName: data.companyName,
      contactName: data.contactName,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      customerId: data.customerId || null,
      assigneeId: data.assigneeId || null,
      value: data.value ? Number(data.value) : null,
      probability: Number(data.probability) || 0,
      source: data.source,
      notes: data.notes,
    };

    if (isNew) create(payload);
    else update({ id, ...payload });
  };

  const defaultValues = isNew
    ? {}
    : {
        companyName: lead?.companyName,
        contactName: lead?.contactName,
        contactEmail: lead?.contactEmail,
        contactPhone: lead?.contactPhone,
        customerId: lead?.customer?.id,
        assigneeId: lead?.assignee?.id,
        value: lead?.value,
        probability: lead?.probability,
        source: lead?.source,
        notes: lead?.notes,
      };

  return (
    <StyledDrawer anchor="right" open={!!open} onClose={onClose}>
      <HubHookFormWrapper defaultValues={defaultValues} onSubmit={handleSubmit}>
        <Stack height="100%">
          <LeadBar onClose={onClose} />
          <Stack padding="20px" gap="20px">
            <LeadDetails lead={lead} isNew={isNew} />
          </Stack>
          {!isNew && lead && (
            <Stack padding="0 20px 20px">
              <LeadTimeline leadId={lead?.id} />
            </Stack>
          )}
        </Stack>
      </HubHookFormWrapper>
    </StyledDrawer>
  );
};

const mapStateToProps = (state) => ({
  open: getIsDialogOpen(state, DIALOG_NAME),
});
const mapDispatchToProps = { _setIsOpenDialog: setIsOpenDialog };

export const LeadDialog = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeadDrawer);

export default LeadDialog;
